import { FormTemplate, TextInput, SubmitFormButton } from 'framework/form';
import useEmployeeScoreService from '../shared/employeeScoreService';
import { LoadingFormLayout, FormRow } from 'framework/ui/layout';
import { MonthFilter, ListHeader, ListPageLayout } from 'framework/list';
import { downloadFile } from 'framework/utils';

const EmployeeScoreList = () => {
  const { getEmployeeScoreReport } = useEmployeeScoreService();

  const handleSubmit = async (data: any) => {
    const {
      TIMELY_CHECKIN = data.TIMELY_CHECKIN || 0.6,
      SAME_DAY_TIME_REPORT = data.SAME_DAY_TIME_REPORT || 0.6,
      EFFECTIVE_CAPACITY = data.EFFECTIVE_CAPACITY || 0.5,
      TICKETS_PLANNED = data.TICKETS_PLANNED || 0.3,
      RESOLVED_TICKETS = data.RESOLVED_TICKETS || 0.3,
      BLOCKED_TICKETS = data.BLOCKED_TICKETS || 0.3,
      REASSIGNED_TICKETS = data.REASSIGNED_TICKETS || 0.3,
    } = data;

    const period = data.period || '2025-07'; // Default period if not provided

    const metricsWeights = {
      TIMELY_CHECKIN,
      SAME_DAY_TIME_REPORT,
      EFFECTIVE_CAPACITY,
      TICKETS_PLANNED,
      RESOLVED_TICKETS,
      BLOCKED_TICKETS,
      REASSIGNED_TICKETS,
    };

    const metricsBounds = {
      TIMELY_CHECKIN: { min: 0, max: 1 },
      SAME_DAY_TIME_REPORT: { min: 0, max: 1 },
      EFFECTIVE_CAPACITY: { min: 0, max: 1 },
      TICKETS_PLANNED: { min: 0, max: 1 },
      RESOLVED_TICKETS: { min: 0, max: 1 },
      BLOCKED_TICKETS: { min: 0, max: 1 },
      REASSIGNED_TICKETS: { min: 0, max: 1 },
    };

    try {
      await getEmployeeScoreReport({ metricsWeights, metricsBounds, period }).then(resp => downloadFile(resp));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error generating report:', error);
    }
  };

  return (
    <>
      <ListPageLayout header={<ListHeader label="Worker Score" icon="fa-clock-o" />}>
        <FormTemplate submitFormFunc={handleSubmit} handleDirty={false}>
          <FormRow>
            <MonthFilter label="Period" source="period" />
          </FormRow>
          <FormRow>
            <TextInput label="Timely checkin weight" source="TIMELY_CHECKIN" placeholder="0.6" />
            <TextInput label="Same day report weight" source="SAME_DAY_TIME_REPORT" placeholder="0.6" />
            <TextInput label="Effective capacity weight" source="EFFECTIVE_CAPACITY" placeholder="0.5" />
            <TextInput label="Tickets planned weight" source="TICKETS_PLANNED" placeholder="0.3" />
            <TextInput label="Resolved tickets weight" source="RESOLVED_TICKETS" placeholder="0.3" />
            <TextInput label="Blocked tickets weight" source="BLOCKED_TICKETS" placeholder="0.3" />
          </FormRow>

          <SubmitFormButton sx={{ marginBottom: '10px' }}>Generate</SubmitFormButton>

          <LoadingFormLayout />
        </FormTemplate>
      </ListPageLayout>
    </>
  );
};

export default EmployeeScoreList;
